import Vue from 'vue';
import header from './header';
import footer from './footer';
import weixin from './weixin';
import content from './content';
import login from './login';

const kComponents = {
  install: function (Vue) {
    Vue.component('k-header', header);
    Vue.component('k-footer', footer);
    Vue.component('k-weixin', weixin);
    Vue.component('k-home-content', content);
    Vue.component('k-login', login);
  }
};

Vue.use(kComponents)
export default { header, footer, weixin, content, login };



// WEBPACK FOOTER //
// ./src/views/home/index.js